import React from 'react'

import { Radio as AntRadio, Space } from 'antd'
import type { RadioChangeEvent } from 'antd'
import { useField, useFormikContext } from 'formik'

import { useBreakPoints } from 'common/hooks'

import FormGroup from '../FormGroup'
import DefaultFieldProps from '../FormGroup/DefaultFieldProps'

import './overrides.less'

type RadioProps = {}
export const RadioV2 = (props: RadioProps) => <AntRadio {...props} />

type RadioGroupItem = {
  name: string
  value: any
}

type RadioGroupProps = DefaultFieldProps & {
  items: RadioGroupItem[]
  onChange?: (value: any) => void
  size?: 'small' | 'middle' | 'large' | undefined
  direction?: 'horizontal' | 'vertical'
  type?: 'button' | 'radio'
  className?: string
  disabled?: boolean
}
export const RadioGroupV2 = (props: RadioGroupProps) => {
  const [field] = useField(props.name)
  const context = useFormikContext()
  const { isLg } = useBreakPoints()

  const onChange = (e: RadioChangeEvent) => {
    context.setFieldValue(props.name, e.target.value)
    props.onChange?.(e)
  }

  const direction = isLg ? 'horizontal' : 'vertical'

  return (
    <FormGroup {...props}>
      <AntRadio.Group
        className={`radioGroupWrap ${props.type === 'button' ? 'radioGroupWrapWithButtons' : ''} ${props.className}`}
        onChange={onChange}
        disabled={props.disabled}
        value={field.value}
        size={props.size}
      >
        <Space direction={props.direction ?? direction}>
          {props.items.map((x) => (
            <AntRadio name={x.name} value={x.value}>
              {x.name}
            </AntRadio>
          ))}
        </Space>
      </AntRadio.Group>
    </FormGroup>
  )
}
